export enum ToolbarAction {
    BULK_DELETE = 'bulk-delete',
    EXPORT = 'export',
}
